export enum ETestIds {
  PresentationBlock = 'presentationBlock',
  PresentationStepsBlock = 'presentationStepsBlock',
  PresentationStepItem = 'presentationStepItem',
  Breadcrumbs = 'breadcrumbs',
  PresentationImg = 'presentationImg',
  PresentationBtn = 'presentationBtn',
  OfferCard = 'offerCard',
  OfferCardBtn = 'offerCardBtn',
  MortgageOfferValidation = 'mortgageOfferValidation',
  MortgageOfferValidationMessage = 'mortgageOfferValidationMessage',
  OfferList = 'offerList',
  OfferListContainer = 'offerListContainer',
  OfferListTitle = 'offerListTitle',
  ShowOffersButton = 'showOffersButton',
  RootMortgageWrapper = 'rootMortgageWrapper',
  ScrollUpButtonFilters = 'scrollUpButton-filters',
  ScrollUpButtonUp = 'scrollUpButton-up',
  InformationalSeo = 'informationalSeo',
  ControlsContainer = 'controlsContainer',
  SeoMarkedList = 'seoMarkedList',
  SeoRichText = 'seoRichText',
  AdvantagesBlock = 'advantagesBlock',
  ProgramsBlock = 'programsBlock',
  BankPartnersBlock = 'bankPartnersBlock',
  BankPartnerCard = 'bankPartnerCard',
  ProgramCard = 'programCard',
  ShortOfferTermsModal = 'shortOfferTermsModal',
  FillApplicationButtonAdvantages = 'fillApplicationButton-advantages',
  FillApplicationButtonPrograms = 'fillApplicationButton-programs',
  FillApplicationButtonOffersList = 'fillApplicationButton-offersList',
  FillApplicationButtonStickyCta = 'fillApplicationButton-stickyCta',
  FillApplicationButtonOfferModal = 'fillApplicationButton-offerModal',
  ShortOfferCard = 'shortOfferCard',
  ShortOffersList = 'shortOffersList',
  ShortOffersEmpty = 'shortOffersEmpty',
  FamilyLoanAmountHint = 'familyLoanAmountHint',
  FamilyLoanAmountHintTooltip = 'familyLoanAmountHintTooltip',
  OffersListing = 'offersListing',
  ShortOffersResetFiltersButton = 'shortOffersResetFiltersButton',
  RedesignStickyBar = 'redesignStickyBar',
  RedesignStickyInfoBar = 'redesignStickyInfoBar',
  RedesignStickyCtaBar = 'redesignStickyCtaBar',
}
